"use client";

import { PointMaterial, Points } from "@react-three/drei";
import { Canvas, useFrame } from "@react-three/fiber";
import * as random from "maath/random";
import { useRef, useState } from "react";
import * as THREE from "three";

/**
 * Influenceページ背景の星団レンダリング
 * StarrySkyコンポーネントを参考にしたThree.jsベースの星団表現
 */
export default function FloatingParticles() {
  return (
    <div className="pointer-events-none fixed inset-0 z-[1]">
      <Canvas camera={{ position: [0, 0, 1] }} style={{ pointerEvents: "none" }}>
        <Stars />
      </Canvas>
    </div>
  );
}

/**
 * 星（星団）のレンダリング
 */
function Stars() {
  const ref = useRef<THREE.Points>(null!);

  // 設定情報
  const STAR_COUNT = 300;
  const STAR_SIZE = 0.004;
  const STAR_COLOR = "#a594f9";
  const SPHERE_RADIUS = 1.2;

  const [sphere] = useState<Float32Array>(() => {
    const starNum = new Float32Array(STAR_COUNT * 3);
    const sphereInfo = {
      radius: SPHERE_RADIUS,
    };

    return random.inSphere(starNum, sphereInfo) as Float32Array;
  });

  useFrame((_, delta) => {
    // 星の移動速度（ゆっくり回転）
    ref.current.rotation.x -= delta / 120;
    ref.current.rotation.y -= delta / 60;
  });

  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points
        ref={ref}
        positions={sphere}
        stride={3}
        frustumCulled={false}
      >
        <PointMaterial
          transparent
          color={STAR_COLOR}
          size={STAR_SIZE}
          sizeAttenuation={true}
          depthWrite={false}
        />
      </Points>
    </group>
  );
}
